export default __webpack_public_path__ + "static/media/scissors.02469434.png";